import { render, staticRenderFns } from "./StakingSelection.vue?vue&type=template&id=0048b1a4&"
import script from "./StakingSelection.vue?vue&type=script&lang=js&"
export * from "./StakingSelection.vue?vue&type=script&lang=js&"
import style0 from "./StakingSelection.vue?vue&type=style&index=0&id=0048b1a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports